"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationButton = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Badge_1 = __importDefault(require("@material-ui/core/Badge"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Notifications_1 = __importDefault(require("@material-ui/icons/Notifications"));
const notification_context_1 = require("../../modules/notification/notification-context");
const web_socket_effect_hook_1 = require("../../providers/web-socket/web-socket-effect-hook");
const tooltip_1 = require("../tooltip/tooltip");
const fetch_hook_1 = require("../../utils/fetch-hook");
const notification_menu_1 = require("./notification-menu");
const notification_styles_1 = require("./notification-styles");
function NotificationButton() {
    const classes = (0, notification_styles_1.useNotificationButtonStyles)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const { notificationUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const anchorRef = (0, react_1.useRef)(null);
    const [count, , resetCount] = (0, fetch_hook_1.useFetch)(`${notificationUrl}/received/count`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
    const openMenu = () => {
        setOpen(true);
    };
    (0, web_socket_effect_hook_1.useWebsocketEffect)(() => {
        resetCount();
    }, ['NOTIFICATION_SENT']);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATIONS_MENU_TITLE", defaultMessage: "Notifikace" }) },
            react_1.default.createElement(Button_1.default, { ref: anchorRef, variant: "contained", color: "primary", onClick: openMenu, disableElevation: true, className: classes.button },
                react_1.default.createElement(Badge_1.default, { badgeContent: count, color: "error", showZero: false, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    } },
                    react_1.default.createElement(Notifications_1.default, { className: classes.notificationIcon })))),
        react_1.default.createElement(notification_menu_1.NotificationsMenu, { open: open, setOpen: setOpen, anchorRef: anchorRef, resetCount: resetCount })));
}
exports.NotificationButton = NotificationButton;
//# sourceMappingURL=notification-button.js.map